export const SET_NEW_DELIVERY_SERVICE = 'SET_NEW_DELIVERY_SERVICE'
